import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LinearProgress } from '@zawarski/eti-ui';
import { MainLayout } from '@/components/layout';
import { Auth } from '@/auth';
import { ErrorBoundary, Personnel, Teams } from '@/pages';

const Home = lazy(() => import('@/pages/Home'));
const MapPage = lazy(() => import('@/pages/Map'));
const TeamsDetail = lazy(() => import('@/pages/TeamsDetail'));
const ARList = lazy(() => import('@/pages/AssessmentRapid/ARList'));
const ARForm = lazy(() => import('@/pages/AssessmentRapid/ARForm'));
const ADList = lazy(() => import('@/pages/AssessmentDetailed/ADList'));
const ADForm = lazy(() => import('@/pages/AssessmentDetailed/ADForm'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Auth />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LinearProgress />}>
                <Home />
              </Suspense>
            ),
          },
          {
            path: 'map',
            element: (
              <Suspense fallback={<LinearProgress />}>
                <MapPage />
              </Suspense>
            ),
          },
          {
            path: 'personnel',
            element: <Personnel />,
          },
          {
            path: 'teams',
            children: [
              {
                index: true,
                element: <Teams />,
              },
              {
                path: 'new',
                element: (
                  <Suspense fallback={<LinearProgress />}>
                    <TeamsDetail />
                  </Suspense>
                ),
              },
              {
                path: ':id',
                element: (
                  <Suspense fallback={<LinearProgress />}>
                    <TeamsDetail />
                  </Suspense>
                ),
              },
            ],
          },
          {
            path: 'assessment',
            children: [
              {
                index: true,
                element: <Navigate to='rapid' replace />,
              },
              {
                path: 'rapid',
                children: [
                  {
                    index: true,
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ARList />
                      </Suspense>
                    ),
                  },
                  {
                    path: 'new',
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ARForm />
                      </Suspense>
                    ),
                  },
                  {
                    path: ':id',
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ARForm />
                      </Suspense>
                    ),
                  },
                ],
              },
              {
                path: 'detailed',
                children: [
                  {
                    index: true,
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ADList />
                      </Suspense>
                    ),
                  },
                  {
                    path: 'new',
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ADForm />
                      </Suspense>
                    ),
                  },
                  {
                    path: ':id',
                    element: (
                      <Suspense fallback={<LinearProgress />}>
                        <ADForm />
                      </Suspense>
                    ),
                  },
                ],
              },
            ],
          },
        ],
        errorElement: <ErrorBoundary />,
      },
    ],
    errorElement: <ErrorBoundary />,
  },
]);
